import { render } from "./OptionsComponent.vue?vue&type=template&id=8f4b65b2&scoped=true"
import script from "./OptionsComponent.vue?vue&type=script&lang=js"
export * from "./OptionsComponent.vue?vue&type=script&lang=js"

import "./OptionsComponent.vue?vue&type=style&index=0&id=8f4b65b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4b65b2"]])

export default __exports__